export default "__VITE_ASSET__DfGDopT0__"